// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-memo.page.title': 'Memos',
    'team-member-memo.page.archive.title': 'Archived Memos',
    'team-member-memo.page.search_results': 'Search Results',
    'team-member-memo.page.create.title': 'Create New Memo',
    'team-member-memo.page.search.title': 'Find Memos',
    'team-member-memo.page.edit.title': 'Edit Memo',
    'team-member-memo.page.view.title': 'Memo',
    'team-member-memo.page.all': 'All',

    'team-member-memo.button.cancel': 'Cancel',
    'team-member-memo.button.select': 'Select',
    'team-member-memo.button.find': 'Find Memos',
    'team-member-memo.button.search': 'Apply',
    'team-member-memo.button.create': 'Save Memo',
    'team-member-memo.button.new': 'New Memo',
    'team-member-memo.button.save': 'Save Changes',
    'team-member-memo.button.archive': 'Archive',
    'team-member-memo.button.delete': 'Permanently Delete',
    'team-member-memo.button.edit': 'Edit',
    'team-member-memo.button.restore': 'Restore',
    'team-member-memo.button.reset': 'Reset',

    'team-member-memo.placeholder.search': 'Search memos',

    'team-member-memo.link.create_first_team_member_memo': 'Click here to create your first memo',
    'team-member-memo.link.team_member_memos': ' Return to Memos',
    'team-member-memo.link.archive': 'Archived Memos',
    'team-member-memo.link.retry': 'Click here to retry',

    'team-member-memo.checkbox.all': 'Check All',
    'team-member-memo.checkbox.actions_label': 'with selected',

    'team-member-memo.label.upload': 'Click to upload or drag and drop',
    'team-member-memo.label.upload_types': 'PDF,JPG,PNG,JPEG',

    'team-member-memo.label.subject': 'Subject',
    'team-member-memo.label.from_team_member': 'From Member',
    'team-member-memo.label.to_team_member': 'To Member',

    'team-member-memo.label.note': 'Note',

    'team-member-memo.label.from__sent_on': 'From sent on',
    'team-member-memo.label.to__sent_on': 'To sent on',
    'team-member-memo.label.sent_on': 'Sent On',

    'team-member-memo.label.attachment': 'Attachment',

    'team-member-memo.label.attachment_name': 'Attachment Name',
    'team-member-memo.label.attachment_size': 'Attachment Size',
    'team-member-memo.label.attachment_mime_type': 'Attachment Mime Type',

    'team-member-memo.label.from__created_at': 'From created at',
    'team-member-memo.label.to__created_at': 'To created at',
    'team-member-memo.label.created_at': 'Created At',

    'team-member-memo.label.from__updated_at': 'From updated at',
    'team-member-memo.label.to__updated_at': 'To updated at',
    'team-member-memo.label.updated_at': 'Updated At',

    'team-member-memo.label.from__deleted_at': 'From deleted at',
    'team-member-memo.label.to__deleted_at': 'To deleted at',
    'team-member-memo.label.deleted_at': 'Deleted At',

    'team-member-memo.label.status': 'Status',

    'team-member-memo.sort.field_label': 'Field',
    'team-member-memo.sort.direction_label': 'Direction',
    'team-member-memo.sort.direction_ascending': 'Ascending',
    'team-member-memo.sort.direction_descending': 'Descending',

    'team-member-memo.modal.title.team_member_memo_archive': 'Archive Memo',
    'team-member-memo.modal.title.team_member_memo_delete_permanently': 'Delete Memo',
    'team-member-memo.modal.title.team_member_memo_restore': 'Restore Memo',

    'team-member-memo.modal.message.team_member_memo_archive': 'Are you sure that you want to move this memo to the archive? | Are you sure that you want to move these memos to the archive?',
    'team-member-memo.modal.message.team_member_memo_delete_permanently':
        'Are you sure that you want to permanently delete this memo? This action cannot be undone. | Are you sure that you want to permanently delete these memos? This action cannot be undone.',
    'team-member-memo.modal.message.team_member_memo_restore': 'Are you sure that you want to restore this memo? | Are you sure that you want to restore these memos?',

    'team-member-memo.success.message.team_member_memo_created': 'Your memo has been created',
    'team-member-memo.success.message.team_member_memo_updated': 'Your memo has been updated',
    'team-member-memo.success.message.team_member_memo_restored': 'Your memo has been restored | All selected memos were restored',
    'team-member-memo.success.message.team_member_memo_deleted': 'Your memo has been permanently deleted | All selected memos were permanently deleted',
    'team-member-memo.success.message.archived_team_member_memos': 'Your memo was moved to the archive | All selected memos were moved to the archive',

    'team-member-memo.error.message.archived_team_member_memos': 'This memo was already moved to the archive | These memos were already moved to the archive',
    'team-member-memo.error.message.team_member_memo_deleted': 'This memo was already permanently deleted | These memos were already permanently deleted',
    'team-member-memo.error.message.team_member_memo_restored': 'This memo was already restored | These memos were already restored',
    'team-member-memo.error.message.error_loading_page': 'Sorry, there was an error loading memo.| Sorry, there was an error loading memos.',

    'team-member-memo.message.search.no_archived_team_member_memos': "You haven't archived any team any member any memos as yet.",
};
